export const getEnvironment = () => {
  const hostname = window.location.hostname;
  if (hostname.includes("stage") || hostname.includes("staging")) {
    return "staging";
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "development";
  }
  return "production";
};
